export default {"src":"/_next/static/media/chat.69c3f389.svg","height":28,"width":27,"blurWidth":0,"blurHeight":0};